import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Spinner, Tab, Tabs } from "react-bootstrap";
import logoAC from "../../assets/Logo Assesment Center-06.png";
import logoGMP from "../../assets/grahamultibintang.jpg";
import closed from "../../assets/closed_bpkh.jpg"

const Closed2 = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { id, id2 } = useParams();
  const [isMobile, setIsMobile] = useState(false);
  const [activeTab, setActiveTab] = useState("informasi");
  const [searchTerm, setSearchTerm] = useState("");
  const [dataPosition, setDataPosition] = useState([]);
  const [dataCompany, setDataCompany] = useState([]);

  // useEffect(() => {
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_URL}ac/recruitment/participant/company_detail/${id2}`,
  //       {
  //         headers: {
  //           Authorization:
  //             "Basic " +
  //             btoa(
  //               `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`
  //             ),
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       setDataCompany(res.data);
  //       setLoading(false);
  //     });
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_URL}ac/recruitment/participant/position/detail/${id}`,
  //       {
  //         headers: {
  //           Authorization:
  //             "Basic " +
  //             btoa(
  //               `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`
  //             ),
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       setDataPosition(res.data.data);
  //       setLoading(false);
  //     });
  // }, []);
  const faqs = [
    {
      question: "Apa itu Officer Development Program (ODP)?",
      answer:
        "ODP adalah program pengembangan karyawan yang dirancang khusus untuk mencetak pemimpin masa depan. Peserta akan menjalani pelatihan intensif, rotasi kerja di berbagai divisi, dan mendapatkan mentoring langsung.",
    },
    {
      question: "Bagaimana cara mendaftar ODP 2025 ini?",
      answer:
        'Pendaftaran hanya dilakukan secara online melalui halaman: https://odp-recruitment.onegml.com/15/16',
    },
    {
      question: "Kapan periode pendaftaran dibuka dan ditutup?",
      answer:
        "Pendaftaran dibuka mulai 23 Mei 2025 dan ditutup pada 1 Juni 2025 pukul 23.59 WIB.",
    },
    {
      question: "Apa saja persyaratan umum untuk melamar ODP di industri perbankan ini?",
      answer:
        'Persyaratan umum dapat dilihat di: https://odp-recruitment.onegml.com/15/16',
    },
    {
      question: "Apakah ada biaya yang harus dibayar untuk mengikuti rekrutmen ini?",
      answer:
        "Tidak ada biaya apapun yang dipungut dalam seluruh proses seleksi ini. Hati-hati terhadap segala bentuk penipuan yang meminta biaya atau menjanjikan kelulusan.",
    },
    {
      question: "Bagaimana tahapan seleksi ODP 2025 di industri perbankan ini?",
      answer:
        "Tahapan seleksi terdiri dari:\n• Seleksi Administrasi\n• Psikotes Online\n• Tes Kompetensi Teknis\n• Assessment Center\n• Interview HR\n• Final Interview (dengan user)",
    },
    {
      question: "Bagaimana saya mengetahui jika lolos seleksi tahap berikutnya?",
      answer:
        "Pengumuman hasil seleksi akan dikirimkan melalui email resmi: admin.ac@gmlperformance.co.id. Pastikan email yang Anda daftarkan aktif dan dapat diakses secara rutin.",
    },
    {
      question: "Apa yang harus dilakukan jika saya mengalami kendala teknis saat pendaftaran?",
      answer:
        "Untuk kendala teknis yang bersifat mendesak (misal kesulitan login atau upload), Anda bisa mengirimkan kontak ke WhatsApp: 0852-1854-8135 (hanya pada jam kerja: Senin–Jumat pukul 09:00–16:00 WIB).",
    },
    {
      question: "Apakah keputusan hasil seleksi dapat diganggu gugat?",
      answer:
        "Tidak. Keputusan panitia seleksi (ONE GML dan user) bersifat mutlak dan tidak dapat diganggu gugat.",
    },
    {
      question: "Apakah boleh mendaftar lebih dari satu posisi?",
      answer:
        "Melamar untuk posisi lebih dari 1 diperbolehkan.",
    },
    {
      question: "Jika saya lolos, kapan saya akan mulai bergabung dalam program ODP ini?",
      answer:
        "Kandidat yang lolos akan mendapatkan informasi jadwal onboarding secara detail melalui email resmi setelah pengumuman akhir seleksi.",
    },
    {
      question: "Apakah setelah menyelesaikan ODP langsung diangkat sebagai karyawan tetap?",
      answer:
        "Peserta yang berhasil menyelesaikan ODP sesuai standar akan menjalani masa evaluasi akhir sebelum diangkat menjadi karyawan tetap sesuai kebijakan perusahaan.",
    },
    {
      question: "Di mana lokasi penempatan kerja setelah lulus ODP?",
      answer:
        "Seluruh peserta ODP wajib bersedia ditempatkan di seluruh wilayah kerja Kalimantan Tengah. Penempatan akan ditentukan berdasarkan kebutuhan organisasi.",
    },
    {
      question: "Bagaimana cara melaporkan jika ada indikasi kecurangan dalam proses seleksi?",
      answer:
        "Anda dapat melaporkan segala bentuk indikasi kecurangan ke:\n• Email resmi: admin.ac@gmlperformance.co.id\n• WhatsApp resmi: 0852-1854-8135 (khusus laporan mendesak)",
    },
  ];

  const filteredFaqs = faqs.filter((faq) =>
    faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
    faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
  );



  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsMobile(window.innerWidth < 768);
  //   };

  //   handleResize();
  //   window.addEventListener("resize", handleResize);

  //   axios
  //     .get(
  //       `${process.env.REACT_APP_URL}ac/recruitment/participant/company_detail/${id2}`,
  //       {
  //         headers: {
  //           Authorization:
  //             "Basic " +
  //             btoa(
  //               `${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`
  //             ),
  //         },
  //       }
  //     )
  //     .then(() => {
  //       setLoading(false);
  //     })
  //     .catch(() => setLoading(false));

  //   return () => window.removeEventListener("resize", handleResize);
  // }, [id2]);

  // if (loading) {
  //   return (
  //     <div className="text-center vh-100 d-flex justify-content-center align-items-center">
  //       <Spinner animation="border" />
  //     </div>
  //   );
  // }

  return (
    <div className="d-flex justify-content-center align-items-center">
    <img src={closed} width={"600px"}></img>
    </div>
    // <>
    //   {/* Banner Section */}
    //   <section className="vh-100">
    //     <div
    //       className="position-relative w-100 h-100"
    //       style={{
    //         backgroundImage: `url("/BPKH-3644.jpg")`,
    //         backgroundSize: "cover",
    //         backgroundPosition: "top center",
    //       }}
    //     >
    //       <div className="d-flex flex-column justify-content-center align-items-center h-100 w-100 bg-dark bg-opacity-50 text-white text-center px-3">
    //         {/* Logo */}
    //         <div className="d-flex flex-row gap-3 justify-content-center align-items-center">
    //         {/* <div
    //           className="bg-white rounded p-1 mb-2"
    //           style={{ maxWidth: "220px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)" }}
    //         >
    //           <img
    //             src={logoAC}
    //             alt="Logo Assessment Center"
    //             className="img-fluid"
    //           />
    //         </div>

    //          <div
    //           className="bg-white rounded p-1 mb-2"
    //           style={{ maxWidth: "220px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)" }}
    //         >
    //           <img
    //             src={logoGMP}
    //             alt="Logo Assessment Center"
    //             className="img-fluid"
    //           />
    //         </div> */}

    //         </div>

    //         {/* Heading Text */}
    //         <h4 className="fw-bold mb-2">
    //           Rekrutmen Terbuka Pegawai BPKH Tahun 2025
    //         </h4>
    //         <p className="mb-4 fs-5">
    //           Selamat Datang Peserta Calon Kandidat Rekrutmen Terbuka Pegawai BPKH Tahun 2025
    //         </p>

    //         {/* Daftar Button */}
    //         <button
    //           className="btn bg-blue text-white px-5 py-2 fs-5"
    //           onClick={() => {
    //             document.getElementById("informasi-umum")?.scrollIntoView({ behavior: "smooth" });
    //           }}
    //         >
    //           Pelajari lebih lanjut
    //         </button>


    //         {/* Warning if mobile */}
    //         {isMobile && <p className="fw-bold mt-3">Daftar melalui laptop/PC</p>}
    //       </div>
    //     </div>
    //   </section>


    //   {/* Tabs Section */}
    //   <section className="container py-5" id="informasi-umum">
    //     <ul className="nav justify-content-center gap-2 mb-4">
    //       <li className="nav-item">
    //         <button
    //           className={`btn px-4 rounded shadow-sm ${activeTab === "informasi"
    //               ? "bg-blue text-white"
    //               : "bg-white text-blue"
    //             }`}
    //           style={{ border: "none" }}
    //           onClick={() => setActiveTab("informasi")}
    //         >
    //           Qualifications
    //         </button>
    //       </li>
    //       <li className="nav-item">
    //         <button
    //           className={`btn px-4 rounded shadow-sm ${activeTab === "faq"
    //               ? "bg-blue text-white"
    //               : "bg-white text-blue"
    //             }`}
    //           style={{ border: "none" }}
    //           onClick={() => setActiveTab("faq")}
    //         >
    //           Frequently Asked Questions (FAQ)
    //         </button>
    //       </li>
    //     </ul>

    //     <div className="d-flex">
    //       {activeTab === "informasi" && (
    //         <>
    //           {/* Kolom kiri */}
    //           <div className="text-start col-md-6">
    //             <ol className="fs-6">
    //               <p className="fw-bold fs-5 mb-4">{dataPosition.position}</p>
    //               <li>Asisten Manajer Investasi Surat Berharga</li>
    //               <li>Asisten Manajer Investasi Surat Berharga Lainnya dan Emas</li>
    //               <li>Asisten Manajer Analisis Portofolio dan Penyelesaian Transaksi</li>
    //               <li>Asisten Manajer Bisnis Digital</li>
    //               <li>Asisten Manajer Pengembangan dan Konfigurasi TI (Fullstack Developer)</li>
    //               <li>Asisten Manajer Pengembangan dan Konfigurasi TI (Mobile Application Developer)</li>
    //               <li>Asisten Manajer Perencanaan dan Arsitektur Teknologi Informasi</li>
    //               <li>Asisten Manajer Manajemen Sistem Informasi (Data Engineer)</li>
    //               <li>Asisten Manajer Transformasi Digital Sistem dan Prosedur Digital dan PMO</li>
    //             </ol>
    //           </div>

    //           {/* Kolom kanan */}
    //           <div className="text-start col-md-6">
    //             <ol className="fs-6">
    //               <p className="fw-bold fs-5 mb-4">Persyaratan Umum</p>
    //               {dataPosition?.requirements?.map((item, index) => (
    //                 <li key={index}>{item.name}</li>
    //               ))}
    //             </ol>
    //           </div>
    //         </>
    //       )}

    //       {activeTab === "faq" && (
    //         <div className="col-md-12">
    //           <input
    //             type="text"
    //             className="form-control mb-4"
    //             placeholder="Cari pertanyaan..."
    //             value={searchTerm}
    //             onChange={(e) => setSearchTerm(e.target.value)}
    //           />

    //           <div className="accordion" id="faqAccordion">
    //             {filteredFaqs.length > 0 ? (
    //               filteredFaqs.map((faq, index) => (
    //                 <div className="accordion-item" key={index}>
    //                   <h2 className="accordion-header" id={`heading${index}`}>
    //                     <button
    //                       className="accordion-button collapsed"
    //                       type="button"
    //                       data-bs-toggle="collapse"
    //                       data-bs-target={`#collapse${index}`}
    //                       aria-expanded="false"
    //                       aria-controls={`collapse${index}`}
    //                     >
    //                       {faq.question}
    //                     </button>
    //                   </h2>
    //                   <div
    //                     id={`collapse${index}`}
    //                     className="accordion-collapse collapse"
    //                     aria-labelledby={`heading${index}`}
    //                     data-bs-parent="#faqAccordion"
    //                   >
    //                     <div className="accordion-body fw-bold">
    //                       {faq.answer.split("\n").map((line, i) => (
    //                         <p key={i} className="mb-1">
    //                           {line}
    //                         </p>
    //                       ))}
    //                     </div>
    //                   </div>
    //                 </div>
    //               ))
    //             ) : (
    //               <p className="text-muted">Tidak ditemukan hasil pencarian.</p>
    //             )}
    //           </div>

    //           {/* WhatsApp Helpdesk Button */}
    //           <div className="text-end mt-4">
    //             <a
    //               href="https://wa.me/6285218548135"
    //               target="_blank"
    //               rel="noopener noreferrer"
    //               className="btn d-inline-flex align-items-center px-4 py-2"
    //               style={{
    //                 backgroundColor: "white",
    //                 color: "#25D366",
    //                 borderRadius: "0.375rem",
    //                 fontWeight: "600",
    //                 textDecoration: "none",
    //                 boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
    //               }}
    //             >
    //               <i
    //                 className="fa-brands fa-whatsapp me-2"
    //                 aria-hidden="true"
    //                 style={{ fontSize: "20px" }}
    //               ></i>
    //               Helpdesk
    //             </a>
    //           </div>
    //         </div>
    //       )}
    //     </div>

    //   </section>

    //   <section className="container pb-3">
    //     <div className="text-center">
    //       <button
    //         className="btn bg-blue text-white px-5 py-2 fs-5 w-100"
    //         onClick={() => navigate(`/form/${id}/${id2}`)}
    //         disabled={isMobile}
    //       >
    //         Daftar Sekarang
    //       </button>

    //       {isMobile && (
    //         <p className="fw-bold mt-3">Daftar melalui laptop/PC</p>
    //       )}
    //     </div>
    //   </section>

    //   <footer className="bg-blue text-white text-center py-3 mt-5">
    //     Copyright © Assessment Center Solutions 2025. <br />
    //     All rights reserved. v 1.0.0
    //   </footer>

    // </>
  );
};

export default Closed2;
